import React from 'react';
import { Tenants } from '../components';

export const Page: React.FC = () => <Tenants />;
